import { UploadedFile } from '@shared/models/uploaded-file'
import { Driver } from '@shared/models/driver.model'
import { Vehicle } from '@shared/models/vehicle.model'
import { BaseModel } from '@shared/models/base.model'
import { toUploadedFile } from '@app/core/helpers/to-uploaded-file'
import { Asset } from '@app/shared/models/asset.model'

export interface DocumentInput {
  cost: number
  issueDate: string
  expDate: string
  note: string
  notifyBefore: number | ''
  title: string
  removeFiles: number[]
  files: File[]
  assetId?: number
  asset?: Asset
  driver?: Driver
  driverId?: string
  vehicle?: Vehicle
  vehicleId?: number
  categoryId?: string
}

export class DocumentItem extends BaseModel {
  id: number
  cost: number
  expDate: string | null
  files: UploadedFile[]
  issueDate: string | null
  note: string | null
  notifyBefore: number | null
  status: DocumentStatus
  title: string
  createdBy: { fullName: string }
  records?: DocumentRecord[]
  noExpiry: boolean
  driver?: Driver
  vehicle?: Vehicle

  constructor(src?: DocumentItem) {
    super(src)
    const toDocumentRecord = (record: DocumentRecord) => new DocumentRecord(record)

    this.files = this.files?.map(toUploadedFile)
    this.records = this.records?.map(toDocumentRecord)
  }
}

export type DriverDocumentItem = DocumentItem & { driver: Driver }
export type VehicleDocumentItem = DocumentItem & { vehicle: Vehicle }
export type AssetDocumentItem = DocumentItem & { asset: Asset }

export class DocumentRecord extends BaseModel {
  id: number
  cost: number
  expDate: string | null
  files: UploadedFile[]
  issueDate: string | null
  note: string | null
  createdBy: { fullName: string }
  createdAt: string
  updatedBy: { fullName: string }
  updatedAt: string
  noExpiry: boolean

  constructor(src?: DocumentRecord) {
    super(src)

    this.files = this.files?.map(toUploadedFile)
  }
}

export interface DocumentRow {
  id: number
  title: string
  expDate: string | null
  issueDate: string | null
  remainingDays: number | null
  status: DocumentStatus
}

export enum DocumentStatus {
  Active = 'active',
  Deleted = 'deleted',
  Expired = 'expired',
  ExpireSoon = 'expire_soon',
  Archive = 'archive',
}

export const DocumentStatusLabel = {
  [DocumentStatus.Active]: 'CLIENT.VEHICLES.DOCUMENTS.STATUS.ACTIVE',
  [DocumentStatus.Archive]: 'CLIENT.VEHICLES.DOCUMENTS.STATUS.ARCHIVE',
  [DocumentStatus.Expired]: 'CLIENT.VEHICLES.DOCUMENTS.STATUS.EXPIRED',
  [DocumentStatus.ExpireSoon]: 'CLIENT.VEHICLES.DOCUMENTS.STATUS.EXPIRE_SOON',
} as const
